import { Panel } from "../Panel"
import type { EscalationRow } from "../dashboard-types"
import { useRegion } from "../store"

export function EscalationMonitor({ rows, demo }: { rows: EscalationRow[]; demo?: boolean }) {
  const openRegion = useRegion((s) => s.openRegion)
  return (
    <Panel title="Escalation Monitor" demo={demo} count={rows.length} helpText="Rising risks since last window">
      <div>
        {rows.map((r) => (
          <div
            key={r.id}
            role="button"
            tabIndex={0}
            onClick={() => openRegion(r.region)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault()
                openRegion(r.region)
              }
            }}
            className="px-3 py-2 border-b border-[color:var(--border)] last:border-b-0 flex items-center gap-3 cursor-pointer hover:bg-[color:var(--surface-hover)] transition-colors focus:outline-none focus:bg-[color:var(--surface-hover)]"
          >
            <div className="w-9 h-9 rounded bg-amber-500/20 text-amber-400 flex items-center justify-center text-sm font-bold tabular-nums">
              {r.score_delta}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm text-[color:var(--text)] truncate">{r.title}</div>
              <div className="text-[10px] uppercase tracking-wider text-[color:var(--text-dim)]">{r.region}</div>
            </div>
            <div className="text-[10px] text-[color:var(--text-muted)] tabular-nums">{r.signals} signals</div>
          </div>
        ))}
      </div>
    </Panel>
  )
}
